export default __webpack_public_path__ + "static/media/Cooking Pot Icon.118b0292.svg";